// @flow

import React from 'react';

import { isBrowser } from '@zapier/common-utils';

const userAgent = isBrowser() ? navigator.userAgent : '';
export const UserAgentContext = React.createContext(userAgent);

export default UserAgentContext;
